import * as actionTypes from "./constants";

const initialState = {
  processing: false,
  error: false,
  rwaMemberList: [],
};

export default function rwamemberReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_RWAMEMBER_INIT_ACTION:
      return {
        ...state,
        rwaLoading: true,
        rwaMemberList: [],
      };
    case actionTypes.FETCH_RWAMEMBER_SUCCESS_ACTION:     
      return {
        ...state,
        rwaLoading: false,
        rwaMemberList: action.payload.response_data.members,
      };
    case actionTypes.FETCH_RWAMEMBER_FAIL_ACTION:
      return {
        ...state,
        rwaLoading: false,
        rwaMemberList:[]
      };
      case actionTypes.DELETE_RWAMEMBER_SUCCESS_ACTION:   
        return {
          ...state,
          rwaMemberList: state.rwaMemberList.filter(
            (item) => item.contactId !== action.payload.contactId
          ),
        }; 

    default:
      return {
        ...state,
      };
  }
}
